import React  from 'react'
import yn from 'yn'

const BkFlowEditAddRoomsToggleDefault = props => {
  const {
    activePropertyPhone,
    addGuestEvent,
    flowQueryConfig,
    guestCount,
    hotelLabels
  } = props

  return (
    yn(process.env.REACT_APP_COMPONENT_ENABLE_MULTI_ROOM) &&
    guestCount <= flowQueryConfig.maximumRooms ?
      <button
        className="btn btn-text-only"
        onClick={() => addGuestEvent()}
        tabIndex={1}
      >
        {hotelLabels.addAdditionalRoomMessage ? hotelLabels.addAdditionalRoomMessage : 'Add Another Room'} +
      </button>
    : guestCount >= flowQueryConfig.maximumRooms ?
      <p className="u-remove-margin u-txt-center u-font-xs u-font-bold">
        {hotelLabels.maximumTotalRoomsMessage ?
          hotelLabels.maximumTotalRoomsMessage
          :
          'You have reached the maximum room total for online bookings.'
        }&nbsp;
        {activePropertyPhone &&
        hotelLabels.maximumTotalRoomsAssistanceMessage ?
          hotelLabels.maximumTotalRoomsAssistanceMessage + ': '
          :
          'For assistance in booking more than ' + flowQueryConfig.maximumRooms + ' rooms please call us at: '
        }
        {activePropertyPhone && activePropertyPhone}
      </p>
      :
      null
  )
}

export default BkFlowEditAddRoomsToggleDefault



// WEBPACK FOOTER //
// ./src/components/edit/guest/layouts/BkFlowEditAddRoomsToggleDefault.js